/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getEventId } from '@e180/domain/lib/event/util';

import ResetPasswordFormDumb from './ResetPasswordFormDumb';
import { resetPassword } from 'src/shared/app/authentication/action/base/authenticationActions';
import {
  getAuthenticationResetToken,
  getAuthenticationUid,
} from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import { throwFormikSubmissionError } from 'src/shared/app/base/form/util/formUtil';
import { loginRoute } from 'src/shared/app/base/route/setting/routeSettings';
import { getRoutePath } from 'src/shared/app/base/route/util/routeUtils';
import { getEventPublicData } from 'src/shared/domain/event/selector/eventSelectors';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  // Self passed
  history: Object,
};

const mapStateToProps = (state: State): Object => ({
  // Used in `mergeProps` only
  resetToken: getAuthenticationResetToken(state),
  uid: getAuthenticationUid(state),
  event: getEventPublicData(state),
});

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { history }: Props,
): Object => {
  const { resetToken, uid, event } = stateProps;

  return {
    ...stateProps,
    handleSubmit({ password }: Object) {
      return dispatch(
        resetPassword(resetToken, uid, password, getEventId(event)),
      )
        .then(() => history.push(getRoutePath(loginRoute)))
        .catch((e) => throwFormikSubmissionError(e));
    },
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(ResetPasswordFormDumb);
